import type { MRT_ColumnFiltersState, MRT_SortingState } from "mantine-react-table";
import { useCallback } from "react";
import { useSearchAfterPagination } from "src/hooks/useSearchAfterPagination";

interface UseMetadataDocumentsQueryParams {
    index: string;
    sorting: MRT_SortingState;
    columnFilters: MRT_ColumnFiltersState;
    globalFilter?: string;
}

export const useMetadataDocumentsQuery = ({
    index,
    sorting,
    columnFilters,
    globalFilter,
}: UseMetadataDocumentsQueryParams) => {
    const buildPayload = useCallback(() => {
        return (
            columnFilters
                ?.filter((val) =>
                    Array.isArray(val.value)
                        ? val.value.filter(Boolean).length > 0
                        : Boolean(val.value),
                )
                .map((filter) => {
                    const key = filter.id.split("__")[1] ?? filter.id;
                    return {
                        key,
                        value: filter.value,
                    };
                }) ?? []
        );
    }, [columnFilters]);

    return useSearchAfterPagination({
        queryKey: ["metadata-documents", index, sorting, columnFilters, globalFilter],
        index: index,
        sorting,
        columnFilters,
        globalFilter,
        buildPayload,
        resetDependencies: [index],
    });
};
